var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.000078 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-.93990049 -.00003949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0649 5.75c-1.68608 0-3.06246 1.37637-3.06246 3.0625 0 1.05438.53813 1.9915 1.35363 2.5432-1.56057.6694-2.66613 2.2168-2.66613 4.0193h.875c0-1.9381 1.56188-3.5 3.49996-3.5.602 0 1.1612.1566 1.6538.4244-.504.6227-.7789 1.3995-.7788 2.2006 0 1.9276 1.5724 3.5 3.5 3.5 1.9277 0 3.5-1.5724 3.5-3.5s-1.5723-3.5-3.5-3.5c-.7371.001-1.4551.2353-2.051.6694-.1933-.1212-.4025-.2232-.6151-.3141.4164-.2809.7575-.6595.9935-1.1028.236-.44334.3597-.93778.3601-1.44 0-1.68613-1.3763-3.0625-3.0625-3.0625zm0 .875c1.2132 0 2.1875.97431 2.1875 2.1875 0 1.2132-.9743 2.1875-2.1875 2.1875-1.21315 0-2.18746-.9743-2.18746-2.1875 0-1.21319.97431-2.1875 2.18746-2.1875Zm4.375 5.25c1.4552 0 2.625 1.1699 2.625 2.625s-1.1698 2.625-2.625 2.625c-1.4551 0-2.625-1.1699-2.625-2.625s1.1699-2.625 2.625-2.625zm-.4375.875v1.3125h-1.3125v.875h1.3125V16.25h.875v-1.3125h1.3125v-.875h-1.3125V12.75Z",
    fill: "#292d34"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.50003952,
    y: 0.49996051,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#292d34",
    strokeDasharray: "2, 2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.93994 4h14v14h-14z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/no_user.0d82585fe5754ff9f86011cd24a65a6d.svg";
export { ForwardRef as ReactComponent };